import { formatBDT } from '../../../domain/formatters/currency';
import { useLocaleStore } from '../../../application/stores/localeStore';

export interface AmountDisplayProps {
  amount: number;
  /** Renders with strikethrough/muted styling for deductions. */
  negative?: boolean;
  bold?: boolean;
}

/**
 * W01 — BDT amount renderer. NaN/undefined degrades to `৳ 0` (never "NaN" on screen).
 * Bengali locale switches to Bengali numerals (৳ ১২,৫০০).
 */
export function AmountDisplay({ amount, negative = false, bold = false }: AmountDisplayProps) {
  const locale = useLocaleStore((s) => s.locale);
  const safe = Number.isFinite(amount) ? amount : 0;
  return (
    <span
      className={`tabular${negative ? ' text-danger' : ''}`}
      style={bold ? { fontWeight: 700 } : undefined}
      data-testid="amount"
    >
      {negative && safe > 0 ? '−' : ''}
      {formatBDT(safe, locale)}
    </span>
  );
}
